import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HeroSectionProps } from '../../types';
import Button from '../atoms/Button';
import './HeroSection.css';

const HeroSection: React.FC<HeroSectionProps> = ({ 
  title = "Crafting Moments, One Cake at a Time",
  subtitle = "From our home oven to your celebrations, discover cakes that make every occasion sweeter.",
  buttonText = "Shop Cakes",
  buttonLink = "/catalog",
  imageSrc = "https://via.placeholder.com/600x400/FFE5E5/1A1A2E?text=Beautiful+Cake"
}) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (buttonLink.startsWith('/')) {
      navigate(buttonLink);
      return;
    }

    window.location.href = buttonLink;
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">{title}</h1>
            <p className="hero-subtitle">{subtitle}</p>
            <Button 
              variant="primary" 
              size="large"
              onClick={handleButtonClick}
              className="hero-button"
            >
              {buttonText}
            </Button>
          </div>
        </div>
        
        <div className="hero-image">
          <img 
            src={imageSrc} 
            alt="Beautiful custom cake" 
            className="hero-img"
            loading="eager"
            fetchPriority="high"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
